import { PAX_TYPE } from './constants'

const getFareFamilyRefs = (selectionsBySliceId, priceKey) =>
  selectionsBySliceId ? Object.values(selectionsBySliceId) : [priceKey]

const getUpsells = (selectionsBySliceId, priceKey, upsellOptions) =>
  getFareFamilyRefs(selectionsBySliceId, priceKey).map((fareRef, index) =>
    upsellOptions.find((uo) => uo.fareFamilyReference[index + 1] === fareRef)
  )

const getFilteredPassengers = (passengers) => Object.keys(passengers).filter((pax) => passengers[pax] > 0)

const getPriceForPax = (price, pax) =>
  price.find((p) => p.type === pax) || price.find((p) => p.type === 'ADULT')

const formatDollar = (amt) => `$${amt.toFixed(2)}`

const getPricingByPaxType = ({ passengers, upsellOptions, selectionsBySliceId, priceKey, price }) => {
  const filteredPassengers = getFilteredPassengers(passengers)
  if (filteredPassengers.length === 1 && passengers[filteredPassengers[0]] === 1) {
    return {}
  }

  const slices = upsellOptions ? getUpsells(selectionsBySliceId, priceKey, upsellOptions) : [{ price }]

  let subtotalPrice = 0

  const priceAndFarePerPaxType = filteredPassengers.map((pax) => {
    const count = passengers[pax]
    let taxes = 0
    let price = 0
    slices.forEach((slice) => {
      const { baseFare, taxesAndFees } = getPriceForPax(slice.price, pax)
      price += baseFare * count
      taxes += taxesAndFees * count
    })
    subtotalPrice += price + taxes
    return {
      title: `${PAX_TYPE[pax]} x ${count}`,
      showTaxPrice: true,
      price: formatDollar(price),
      taxes: [
        {
          name: 'Taxes and Fees',
          displayPricePerPerson: formatDollar(taxes),
        },
      ],
    }
  })

  return { subtotalPrice: formatDollar(subtotalPrice), priceAndFarePerPaxType }
}

export { getPricingByPaxType }
